"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.feeComponentFromObj = exports.eFeeType = void 0;
const flatFee_1 = __importDefault(require("./flatFee"));
const percentageFee_1 = __importDefault(require("./percentageFee"));
var eFeeType;
(function (eFeeType) {
    eFeeType["PERCENTAGE"] = "PERCENTAGE";
    eFeeType["FLAT_FEE"] = "FLAT_FEE";
})(eFeeType = exports.eFeeType || (exports.eFeeType = {}));
const feeComponentFromObj = (data) => {
    if (!Number.isNaN(data.value)) {
        const partnerId = data.partnerId || data.id;
        const value = Number(data.value);
        if (data.type === eFeeType.FLAT_FEE ||
            data.unit === "flatFee" ||
            data.unit === "currency") {
            if (!data.currency) {
                throw new Error("Currency not specified for flat fee");
            }
            return new flatFee_1.default(data.currency, value, partnerId);
        }
        return new percentageFee_1.default(value, partnerId);
    }
    return undefined;
};
exports.feeComponentFromObj = feeComponentFromObj;
//# sourceMappingURL=types.js.map